
import { SearchBox } from 'react-instantsearch-dom';

export default SearchBox



// WEBPACK FOOTER //
// ./src/whatson/components/SearchBox.js